/** The tab named in the address, when it is one this person may see; otherwise the default. */
export const pickTab = (value, allowed, fallback) => (value && allowed.includes(value) ? value : fallback);
